import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { dialogProps as Q } from "./dialogProps.js";
import U from "./styles/index.cssr.js";
import T from "../../_mixins/use-theme.js";
import X from "../../_mixins/use-config.js";
import { useRtl as Y } from "../../_mixins/use-rtl.js";
import Z from "../styles/light.js";
import { createKey as ee } from "../../_utils/cssr/index.js";
import { getMargin as oe } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import { useThemeClass as te } from "../../_mixins/use-css-vars-class.js";
import { resolveWrappedSlot as _, resolveSlot as S } from "../../_utils/vue/resolve-slot.js";
import { render as a } from "../../_utils/vue/render.js";
import ie from "../../_internal/icon/src/Icon.js";
import k from "../../button/src/Button.js";
import ne from "../../_internal/close/src/Close.js";
import B from "../../_internal/icons/Info.js";
import le from "../../_internal/icons/Success.js";
import se from "../../_internal/icons/Warning.js";
import re from "../../_internal/icons/Error.js";
import { defineComponent as ce, computed as z, h as o } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const ae = {
  default: () => o(B, null),
  info: () => o(B, null),
  success: () => o(le, null),
  warning: () => o(se, null),
  error: () => o(re, null)
}, ke = ce({
  name: "Dialog",
  alias: [
    "NimbusConfirmCard",
    // deprecated
    "Confirm"
    // deprecated
  ],
  props: Object.assign(Object.assign({}, T.props), Q),
  slots: Object,
  setup(n) {
    const {
      mergedComponentPropsRef: d,
      mergedClsPrefixRef: c,
      inlineThemeDisabled: h,
      mergedRtlRef: x
    } = X(n), m = Y("Dialog", x, c), g = z(() => {
      var t, i;
      const {
        iconPlacement: r
      } = n;
      return r || ((i = (t = d == null ? void 0 : d.value) === null || t === void 0 ? void 0 : t.Dialog) === null || i === void 0 ? void 0 : i.iconPlacement) || "left";
    });
    function y(t) {
      const {
        onPositiveClick: i
      } = n;
      i && i(t);
    }
    function f(t) {
      const {
        onNegativeClick: i
      } = n;
      i && i(t);
    }
    function R() {
      const {
        onClose: t
      } = n;
      t && t();
    }
    const u = T("Dialog", "-dialog", U, Z, n, c), v = z(() => {
      const {
        type: t
      } = n, i = g.value, {
        common: {
          cubicBezierEaseInOut: r
        },
        self: {
          fontSize: p,
          lineHeight: C,
          border: e,
          titleTextColor: b,
          textColor: $,
          color: l,
          closeBorderRadius: P,
          closeColorHover: M,
          closeColorPressed: N,
          closeIconColor: O,
          closeIconColorHover: D,
          closeIconColorPressed: E,
          closeIconSize: j,
          borderRadius: H,
          titleFontWeight: w,
          titleFontSize: V,
          padding: W,
          iconSize: F,
          actionSpace: K,
          contentMargin: L,
          closeSize: q,
          [i === "top" ? "iconMarginIconTop" : "iconMargin"]: A,
          [i === "top" ? "closeMarginIconTop" : "closeMargin"]: G,
          [ee("iconColor", t)]: J
        }
      } = u.value, I = oe(A);
      return {
        "--n-font-size": p,
        "--n-icon-color": J,
        "--n-bezier": r,
        "--n-close-margin": G,
        "--n-icon-margin-top": I.top,
        "--n-icon-margin-right": I.right,
        "--n-icon-margin-bottom": I.bottom,
        "--n-icon-margin-left": I.left,
        "--n-icon-size": F,
        "--n-close-size": q,
        "--n-close-icon-size": j,
        "--n-close-border-radius": P,
        "--n-close-color-hover": M,
        "--n-close-color-pressed": N,
        "--n-close-icon-color": O,
        "--n-close-icon-color-hover": D,
        "--n-close-icon-color-pressed": E,
        "--n-color": l,
        "--n-text-color": $,
        "--n-border-radius": H,
        "--n-padding": W,
        "--n-line-height": C,
        "--n-border": e,
        "--n-content-margin": L,
        "--n-title-font-size": V,
        "--n-title-font-weight": w,
        "--n-title-text-color": b,
        "--n-action-space": K
      };
    }), s = h ? te("dialog", z(() => `${n.type[0]}${g.value[0]}`), v, n) : void 0;
    return {
      mergedClsPrefix: c,
      rtlEnabled: m,
      mergedIconPlacement: g,
      mergedTheme: u,
      handlePositiveClick: y,
      handleNegativeClick: f,
      handleCloseClick: R,
      cssVars: h ? void 0 : v,
      themeClass: s == null ? void 0 : s.themeClass,
      onRender: s == null ? void 0 : s.onRender
    };
  },
  render() {
    var n;
    const {
      bordered: d,
      mergedIconPlacement: c,
      cssVars: h,
      closable: x,
      showIcon: m,
      title: g,
      content: y,
      action: f,
      negativeText: R,
      positiveText: u,
      positiveButtonProps: v,
      negativeButtonProps: s,
      handlePositiveClick: t,
      handleNegativeClick: i,
      mergedTheme: r,
      loading: p,
      type: C,
      mergedClsPrefix: e
    } = this;
    (n = this.onRender) === null || n === void 0 || n.call(this);
    const b = m ? o(ie, {
      clsPrefix: e,
      class: `${e}-dialog__icon`
    }, {
      default: () => _(this.$slots.icon, (l) => l || (this.icon ? a(this.icon) : ae[this.type]()))
    }) : null, $ = _(this.$slots.action, (l) => l || u || R || f ? o("div", {
      class: [`${e}-dialog__action`, this.actionClass],
      style: this.actionStyle
    }, l || (f ? [a(f)] : [this.negativeText && o(k, Object.assign({
      theme: r.peers.Button,
      themeOverrides: r.peerOverrides.Button,
      ghost: !0,
      size: "small",
      onClick: i
    }, s), {
      default: () => a(this.negativeText)
    }), this.positiveText && o(k, Object.assign({
      theme: r.peers.Button,
      themeOverrides: r.peerOverrides.Button,
      size: "small",
      type: C === "default" ? "primary" : C,
      disabled: p,
      loading: p,
      onClick: t
    }, v), {
      default: () => a(this.positiveText)
    })])) : null);
    return o("div", {
      class: [`${e}-dialog`, this.themeClass, this.closable && `${e}-dialog--closable`, `${e}-dialog--icon-${c}`, d && `${e}-dialog--bordered`, this.rtlEnabled && `${e}-dialog--rtl`],
      style: h,
      role: "dialog"
    }, x ? _(this.$slots.close, (l) => {
      const P = [`${e}-dialog__close`, this.rtlEnabled && `${e}-dialog--rtl`];
      return l ? o("div", {
        class: P
      }, l) : o(ne, {
        clsPrefix: e,
        class: P,
        onClick: this.handleCloseClick
      });
    }) : null, m && c === "top" ? o("div", {
      class: `${e}-dialog-icon-container`
    }, b) : null, o("div", {
      class: [`${e}-dialog__title`, this.titleClass],
      style: this.titleStyle
    }, m && c === "left" ? b : null, S(this.$slots.header, () => [a(g)])), o("div", {
      class: [`${e}-dialog__content`, $ ? "" : `${e}-dialog__content--last`, this.contentClass],
      style: this.contentStyle
    }, S(this.$slots.default, () => [a(y)])), $);
  }
});
export {
  ke as NDialog
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dialog/src/Dialog.js
// module id = 948
// module chunks = 67